import React from "react";
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import moment from "moment";
import { utils } from "../../../../utils/utils";
import { pickLastUse } from "../apiKeyPayloadUtils";

const dateFmt = "MMM D, h:mm a";

const fmt = (v) => {
  if (v == null || v === "" || !moment(v).isValid()) {
    return "—";
  }
  return utils.formatDateTime(v, dateFmt);
};

const pickRevokedAt = (k) => k?.revokeAt ?? k?.revokedAt;

const formatConfig = (config) => {
  if (config == null) {
    return "—";
  }
  if (typeof config === "string") {
    return config;
  }
  try {
    return JSON.stringify(config, null, 2);
  } catch {
    return String(config);
  }
};

const ExternalApiKeyDetailsModal = ({ record, onClose }) => {
  if (!record) {
    return null;
  }

  return (
    <Modal isOpen={true} size="md" scrollable toggle={onClose}>
      <ModalHeader toggle={onClose} tag="h5">
        API External Key Details{record.name ? ` — ${record.name}` : ""}
      </ModalHeader>
      <ModalBody>
        <Row className="mb-2">
          <Col sm="4" className="text-muted small">
            Expires
          </Col>
          <Col sm="8" className="small text-break">
            {fmt(record.expiresAt)}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm="4" className="text-muted small">
            Last use
          </Col>
          <Col sm="8" className="small text-break">
            {fmt(pickLastUse(record))}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm="4" className="text-muted small">
            Revoked
          </Col>
          <Col sm="8" className="small text-break">
            {fmt(pickRevokedAt(record))}
          </Col>
        </Row>
        <Row>
          <Col sm="4" className="text-muted small">
            Config
          </Col>
          <Col sm="8">
            <pre
              className="small bg-light p-2 rounded text-break mb-0"
              style={{ maxHeight: 220, overflow: "auto" }}
            >
              {formatConfig(record.config)}
            </pre>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose} type="button">
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ExternalApiKeyDetailsModal;
